// test1006
(1006 && 0);
